module.exports = __webpack_public_path__ + "images/harmonie-7ee82a4399d276e036a0f9924a092d22.jpg";